<!-- Button -->
<button
    mat-icon-button
    (click)="toggleFullscreen()">
    <ng-container class="text-gray-300" [ngTemplateOutlet]="iconTpl || defaultIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #defaultIconTpl>
    <mat-icon  class="text-gray-300" [svgIcon]="'heroicons_outline:arrows-expand'"></mat-icon>
</ng-template>
